import React from 'react'
import LButton from "../../../components/lui/inputs/buttons/LButton"
import css from './AppListItem.module.css'


/**
 *  StoreLink
 *  @typedef StoreLink
 *  @property {string} href
 *  @property {string} title
 */

/**
 *
 * @param {string} title
 * @param {string} subtitle
 * @param {string} image
 * @param {string} donateLabel
 * @param {string[]} rawText
 * @param {StoreLink[]} storeLinks
 * @param {function()} donatePressed
 * @returns {JSX.Element}
 * @constructor
 */
export default function AppListItem({ title, subtitle, image, donateLabel, rawText=[], storeLinks=[], donatePressed }){

    const path = process.env.PUBLIC_URL+'/assets/i/apps/'+image
    const style = { backgroundImage: 'url('+path+')' }
    const text = rawText.join('')

    return (
        <div className={css.item}>
            <div className={css.avatar} style={style}/>
            <h2 className={css.title}>{title}</h2>
            <div className={css.subtitle}>{subtitle}</div>
            <div className={css.info}>
                <div dangerouslySetInnerHTML={{__html: text}}/>
            </div>
            <div className={css.storeLinks}>{
                storeLinks.map((link, index) => (<a key={index} href={link.href}>{link.title}</a>))
            }
            </div>
            <div className={css.actions}>
                <LButton onClick={donatePressed} variant='surface' shape='round'>{donateLabel}</LButton>
            </div>
        </div>
    )

}
